export default "__VITE_ASSET__cP24n8dE__"